import { render, staticRenderFns } from "./PortfolioProductsList.vue?vue&type=template&id=0fea4ec9&scoped=true"
import script from "./PortfolioProductsList.vue?vue&type=script&lang=ts&scoped=true"
export * from "./PortfolioProductsList.vue?vue&type=script&lang=ts&scoped=true"
import style0 from "./PortfolioProductsList.vue?vue&type=style&index=0&id=0fea4ec9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fea4ec9",
  null
  
)

export default component.exports